<template>
  <div v-url class="mod_term_list" :style="{ opacity: visible ? 1 : 0 }">
    <div class="term_list">
      <div class="item" v-if="activeTerm">
        <div id="common" v-if="activeTerm.common && !onlySerialpay" v-html="activeTerm.common"></div>
        <div id="serialpay" v-if="activeTerm.serialpay && !onlyCommon" v-html="activeTerm.serialpay"></div>
      </div>
      <div class="item history-item" v-if="histroyTerm && histroyTerm.length > 0">
        <h3>历史版本：</h3>
        <div
          :key="key"
          @click="onHistoryLinkClick(el.version)"
          class="history-link"
          v-for="(el, key) in histroyTerm">
          《{{el.title}}》{{el.version}} 更新
        </div>
      </div>
      <div class="no-content" v-if="ready && !activeTerm && !histroyTerm">
        当前暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { getTerm } from './service/wuji';
import { hideShare } from './util/index';
import atom from '@tencent/vft-atom';
import util from '@tencent/vft-common/util';

const type = util.getUrlParam('type') || ''; // 指定的协议类型
const modId = util.getUrlParam('modId'); // 指定锚点的模块

export default {
  data() {
    return {
      activeTerm: null, // 当前要展示的协议
      histroyTerm: null, // 历史版本协议
      ready: false,
      onlyCommon: type === 'common',
      onlySerialpay: type === 'serialpay',
      visible: false,
    };
  },
  async mounted() {
    const { activeTerm, histroyTerm } = await getTerm();
    this.activeTerm = activeTerm;
    this.histroyTerm = histroyTerm;
    this.ready = true;
    if (this.activeTerm?.title) {
      document.title = this.activeTerm.title;
    }
    hideShare();
    // 延迟50ms（经验值）定位，否则定位不准确
    setTimeout(() => {
      this.scrollToModule();
      this.visible = true;
    }, 50);
  },
  methods: {
    // 通过modId跳转指定模块
    scrollToModule() {
      const $mod = document.getElementById(modId);
      if ($mod) {
        window.scrollTo(0, $mod.offsetTop);
      }
      // 兼容旧的逻辑
      if (location.hash.includes('serialpay')) {
        setTimeout(() => {
          const dom = document.getElementById('serialpay');
          dom?.scrollIntoView?.();
        }, 500);
      }
    },
    onHistoryLinkClick(version) {
      const url = util.setUrlParam('version', version, location.href);
      atom.openUrl(url);
    },
  },
};
</script>

<style>
.no-content {
  text-align: center;
  padding-top: 200px;
}
.history-link {
  color: rgb(102, 163, 224);
  line-height: 2;
}
img{
  width: 100%;
  display: block;
  max-width: 520px;
}
</style>
